import { UPDATE_LOCATIONS_SORTING } from '../constants/action-types';
export const updateLocationsSorting = ({ direction, field }) => ({
    type: UPDATE_LOCATIONS_SORTING,
    payload: {
        direction,
        field,
    },
});
